export default __webpack_public_path__ + "static/media/Complaints-Policy.2a270be9.pdf";